import serviceRequest from '@/api/service-management/service-request'

import { baseState, baseMutations } from '@/store/mixins'
import { split } from "lodash";
import moment from 'moment'

export const state = {
  ...baseState,
  dateRange: [
    moment().startOf('month').format('DD-MM-YYYY'),
    moment().endOf('month').format('DD-MM-YYYY')
  ],
  formViewDatas: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formViewDatas = data;
    } else {
      split(index, ",").forEach(el => {
        state.formViewDatas[el] = data[el];
      });
    }
  },
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
          date_between: _.join(
            context.state.searchAllDate && context.state.search
              ? undefined
              : context.state.dateRange,
            ','
          )
        }
      },
      attrubutes
    )
    return serviceRequest.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return serviceRequest.store(data)
  },
  update(context, { id, data }) {
    return serviceRequest.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await serviceRequest.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  changeRequiredSparePart(context, { id, data }) {
    return serviceRequest.changeRequiredSparePart(id, data);
  },
  changeOwner(context, { id, data }) {
    return serviceRequest.changeOwner(id, data);
  },
  changeServiceStatus(context, { id, data }) {
    return serviceRequest.changeServiceStatus(id, data);
  },
  preview(context, id) {
    return serviceRequest.preview(id)
  },
  destroy(context, id) {
    return serviceRequest.destroy(id)
  },
  generateInv(context, data) {
    return serviceRequest.generateInv(data)
  },
  async getFormViewModel(context, { params, index }) {
    let response = await serviceRequest.formViewModel({ params: params });
    context.commit("SET_VIEW_MODELS", {
      data: response.data,
      index: index
    });
    return Promise.resolve(response);
  }
}
